import React, { Component } from 'react';
import PropTypes from 'prop-types';
import defaultJobImage from '../../../../images/default_skill.jpeg';
import { appPath } from '../../../../constants';
import { jobWorkerStatuses } from '../../../../constants/jobs';
import JobWorkerHistory from './JobWorkerHistory';

export default class JobInfoWorker extends Component {
  navToDetails = () => {
    const { history, jobData: { id } } = this.props;
    history.push(`/${appPath}/jobs/${id}`);
  };

  render () {
    const { jobData } = this.props;
    const { icon_url, skill_label, company_name, location_name, job_worker: { status }, timeShiftUI } = jobData;
    return (
      <div className={`job-wrapper status-${status} row`} onClick={this.navToDetails}>
        <div className='py-1 col-12 col-sm-5 col-md-3 d-flex align-center'>
          <div
            className='job-image'
            style={{ backgroundImage: `url('${icon_url || defaultJobImage}')` }}
          />
          <div>
            <h5>{skill_label}</h5>
            { company_name && <p className='pt-1 text-muted'>{ company_name }</p> }
          </div>
        </div>

        <div className='py-1 col-6 col-sm-3 col-md-2 col-xl-2'>
          <p>{ timeShiftUI }</p>
          <p className='text-muted'>Time</p>
        </div>

        <div className='col-6 col-sm-3 col-md-2 col-xl-2'>
          <p>{location_name}</p>
          <p className='text-muted'>Location</p>
        </div>

        <div className='col-6 col-md-3'>
          <JobWorkerHistory {...jobData.job_worker} time_zone_id={jobData.time_zone_id} />
        </div>

        <div className='col-6 col-sm-3 col-md-2 col-xl-2'>
          <div className={`status-btn ${status}`}>
            {jobWorkerStatuses.find(jobWorkerStatus => jobWorkerStatus.id === status).value}
          </div>
        </div>
      </div>
    );
  }
}

JobInfoWorker.propTypes = {
  history: PropTypes.object,
  jobData: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/app/jobsList/JobInfoWorker/index.js